module.exports = __webpack_public_path__ + "static/media/learning12StepM.de1188d1.png";